export default "__VITE_ASSET__44f0ca1c__"